<template>
  <div class="item" :class="type">
    <div class="contact">
      <div class="title">{{ title }}</div>
      <div class="info phone">
        <div class="icon" v-html="require('@/assets/icons/phone.svg')" />
        <a class="link" :href="phoneLink" v-text="phone" />
      </div>
      <div class="info mail">
        <div class="icon" v-html="require('@/assets/icons/at.svg')" />
        <a class="link" :href="mailLink" v-text="mail" />
      </div>
    </div>
    <div class="people">
      <div class="person" v-for="person in people" :key="person.name">
        <div class="img">
          <img v-if="person.img" :src="person.img" />
          <v-img v-else v-bind="require('@/assets/contact/no-person.jpg')" />
        </div>
        <div class="name">
          {{ person.name }}<br />
          {{ person.title }}<br />
          {{ person.phone }}<br />
          {{ person.email }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: {
		type: {type: String, required: false},
		title: {type: String, required: true},
		phone: {type: String, required: true},
		mail: {type: String, required: true},
		people: {type: Array, required: true},
	},
	computed: {
		phoneLink: (t) => `tel:${t.phone.split(" ").join("")}`,
		mailLink: (t) => `mailto:${t.mail}`,
	},
};
</script>

<style lang="scss" scoped>
.item {
  width: 100%;
  display: inline-flex;
  padding: 5em em(27) 2em 7em;
  border-bottom: 1px solid $grey2;

  a {
    color: $petroleum1;
  }

  @include res(tablet) {
    flex-direction: column;
    padding: em(27);
  }

  &.header {
    background-color: $petroleum1;
    color: white;

    a {
      color: white;
    }
  }

  &.last {
    border-bottom: 0;
  }

  .contact {
    flex-shrink: 0;
    min-width: 240px;

    @include res(mobile) {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .title {
      letter-spacing: 0.5px;
      margin: 3em 0;
      font-size: em(17);
      font-weight: 700;

      @include res(mobile) {
        margin: 1em 0 2em;
      }
    }

    .info {
      display: flex;
      font-size: em(16);
      font-weight: 300;
      margin-top: 0.5em;

      .icon {
        /deep/ svg {
          width: 1em;
          height: 1em;
          path {
            fill: $grey1;
          }
        }
      }

      .link {
        margin-left: 1em;
      }
    }
  }
  .people {
    width: 100%;

    @include res(tablet) {
      margin-top: 2em;
    }

    @include res(mobile) {
      margin-bottom: 1em;
    }

    .person {
      display: inline-block;
      margin: 0 0 2em 1em;
      width: 14em;

      @include res(tablet) {
        width: 32%;
        margin: 0;

        &:nth-child(3n + 2) {
          margin-left: 2%;
          margin-right: 2%;
        }
      }

      @include res(mobile) {
        width: 100%;
        margin-top: 1em;

        &:nth-child(2n + 2) {
          margin-left: 0;
          margin-right: 0;
        }
      }

      .img {
        line-height: 0;
      }

      .name {
        text-align: center;
        margin-top: 1em;
        font-size: em(13);
        font-weight: 300;
      }
    }
  }
}
</style>
